import { findFeatureValue as a, findFeatureVisibility as r } from "./utils.js";
const l = function(t, i) {
  let e = {};
  if (t)
    if (t.FeatureFlagService)
      ({ FeatureFlagService: e } = t);
    else
      return t.FeatureFlagService = e, i(e);
  return e;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(t) {
    let i = {};
    return t.setFeatureFlagData = (e) => {
      i = e;
    }, t.getFeatureValue = (e) => a(i, e), t.getFeatureVisibility = (e) => r(i, e), t;
  }
);
export {
  l as FeatureFlagService
};
//# sourceMappingURL=FeatureFlagService.js.map
